import { AlcoholicIntakeOption } from "@/utils/types";

export const alcoholicIntakeOptions: AlcoholicIntakeOption[] = [
    {
        label: "Cerveja",
        value: "beer",
        code: "80450-0",
        display: "Beer intake 24 hour",
        observationType: "beerIntake24h",
        system: "http://loinc.org",
        unit: "mL/(24.h)",
    },
    {
        label: "Destilado",
        value: "distilled",
        code: "80478-1",
        display: "Distilled alcohol intake 24 hour",
        observationType: "distilledAlcoholIntake24h",
        system: "http://loinc.org",
        unit: "mL/(24.h)",
    },
    {
        label: "Vinho",
        value: "wine",
        code: "80479-9",
        display: "Wine intake 24 hour",
        observationType: "wineIntake24h",
        system: "http://loinc.org",
        unit: "mL/(24.h)",
    },
];

